import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DependentDetailForm } from 'Components/ComponentLibrary/Organisms/DependentDetailForm/DependentDetailForm';
import {
  FDContentContainer, FDPaper, FDPrimaryActionButton, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const DependentLayout = ({ onSuccessfulSubmit }) => {
  const {
    resource, onDelete, onSubmit, saving,
  } = useMetaLayoutContext();

  return (
    <FDContentContainer maxWidth={'md'}>
      <FDPaper appearance={'elevated'} padding={400} width={'100%'}>
        <FDStack direction={'column'} spacing={4}>
          <DependentDetailForm
            onProfileImageUpload={onSuccessfulSubmit}
          />
          <FDStack justifyContent={'flex-end'} spacing={2}>
            {resource.meta().canDelete() ? (
              <FDSecondaryActionButton
                onClick={() => {
                  return onDelete(resource);
                }}
                label={'Remove Member'}
              />
            ) : null}
            <FDPrimaryActionButton
              loading={saving}
              onClick={() => onSubmit()}
              label={'Save Changes'}
            />
          </FDStack>
        </FDStack>
      </FDPaper>
    </FDContentContainer>
  );
};

DependentLayout.propTypes = {
  onSuccessfulSubmit: PropTypes.func.isRequired,
};
